"use client";

import { Attendee } from "@prisma/client";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import {
    STRIPE_CURRENCIES,
    StripeCurrency,
} from "~/utils/stripe_currency_codes";
import { EventFormData } from "../v3/events-components/EventViewAndEdit/EventFormDataType";

type RSVPTextProps = {
    attendee?: Attendee | null;
    event: EventBySlugOutput;
};

const RSVPText = (props: RSVPTextProps) => {
    const form = useFormContext<EventFormData>();

    const [text, setText] = useState<React.ReactNode>();
    const defaultCurrency = STRIPE_CURRENCIES[0];
    const initialCurrency =
        STRIPE_CURRENCIES.find(
            (c) => c.code === form.getValues("currencyCode"),
        ) ?? defaultCurrency;
    const [currency] = useState<StripeCurrency>(
        initialCurrency as StripeCurrency,
    );

    useEffect(() => {
        if (props.event.stripeProductId) {
            setText(
                <p className="flex flex-row items-center">
                    Buy a ticket for{" "}
                    <span className="ml-1">{currency.icon}</span>{" "}
                    {props.event.priceDollars} {currency.code}
                </p>,
            );
        } else {
            setText(<p>Attend</p>);
        }
    }, [props.attendee, props.event]);

    return <>{text}</>;
};

export default RSVPText;

export const isEventOver = (startTime: Date, endTime?: Date | null) => {
    const localTz = new Date(startTime);
    const startTimeUtc: number =
        localTz.getTime() - localTz.getTimezoneOffset() * 60000;
    let endTimeUtc: number | null = null;

    if (endTime) {
        const localTz = new Date(endTime);
        endTimeUtc = localTz.getTime() - localTz.getTimezoneOffset() * 60000;
    }

    const now: number = new Date().getTime();
    const twelveHoursAgo = now - 12 * 60 * 60 * 1000;

    if (startTimeUtc < now) {
        // some of the events have bugged end times so we have to put this check here
        if (endTimeUtc === null || endTimeUtc < startTimeUtc) {
            // if startTime is more than 12 hours ago, then event is over
            if (startTimeUtc < twelveHoursAgo) {
                return true;
            }
        }

        return true;
    }
    return false;
};
